import { usePublicOrder } from "../queries/use-public-order";
import type { NonReturnableLineItem, NonReturnableReason, OrderLineItem } from "../types";

const NON_RETURNABLE_REASONS: NonReturnableReason[] = [
  "OUTSIDE_RETURN_WINDOW",
  "NON_RETURNABLE_PRODUCT_TAG",
  "NON_RETURNABLE_METAFIELD_TAG",
  "NON_RETURNABLE_CUSTOM_ATTRIBUTE_TAG",
];

function getNonReturnableReason(lineItem: OrderLineItem): NonReturnableReason | null {
  const reason = (lineItem as any).nonReturnableReason as string | undefined;
  if (reason && NON_RETURNABLE_REASONS.includes(reason as NonReturnableReason)) {
    return reason as NonReturnableReason;
  }
  return null;
}

/**
 * Returns line items that are non-returnable (e.g. outside return window, product tag).
 * Used to show disabled rows with a distinct badge in the article selection list.
 */
export function useNonReturnableItems(orderId: string): NonReturnableLineItem[] {
  const { data: order } = usePublicOrder(orderId);
  const lineItems: OrderLineItem[] = order?.lineItems ?? [];

  return lineItems.flatMap((li) => {
    const reason = getNonReturnableReason(li);
    return reason ? [{ lineItem: li, reason }] : [];
  });
}
